import React from 'react';
import { useParams } from 'react-router-dom';
import TournamentAdminForm from './components/TournamentAdminForm';

/** `/association/tournaments/new` creates; `/association/tournaments/:id` edits. */
const TournamentAdminFormPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const tournamentId = id && /^\d+$/.test(id) ? Number(id) : undefined;

  return <TournamentAdminForm tournamentId={tournamentId} />;
};

export default TournamentAdminFormPage;
